import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de Iniciar proceso
 **/

class CustomIniciarProceso extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                                   = this.initForm.bind(this);
        this.successDatosFicha                          = this.successDatosFicha.bind(this);
        this.itemsFichas                                = this.itemsFichas.bind(this);
        this.successItemsFichas                         = this.successItemsFichas.bind(this); 
        this.gridOptionsItemFichas                      = Object.assign({}, this.gridOptions);  
        this.totalKilos                                 = this.totalKilos.bind(this);
        this.successTotalkilos                          = this.successTotalkilos.bind(this);
        this.modalEnvase                                = this.modalEnvase.bind(this);  
        this.gridOptionsTbEnvase                        = Object.assign({}, this.gridOptions);
        this.guardarEnvase                              = this.guardarEnvase.bind(this);
        this.successGuardarEnvase                       = this.successGuardarEnvase.bind(this);
        this.productosDelEnvasado                       = this.productosDelEnvasado.bind(this);
        this.successProductosDelEnvasado                = this.successProductosDelEnvasado.bind(this);
        this.gridOptionsProductosEnvasado               = Object.assign({}, this.gridOptions);
        this.setChangeProductosEnvasado                 = this.setChangeProductosEnvasado.bind(this);
        this.setChangeProductosEnvasadoclick            = this.setChangeProductosEnvasadoclick.bind(this);  
        this.successProductosDelEnvasadoClick           = this.successProductosDelEnvasadoClick.bind(this);
        this.cancelarEnvase                             = this.cancelarEnvase.bind(this);
        this.iniciarProceso                             = this.iniciarProceso.bind(this);
        this.cantidadxEnvasar                           = this.cantidadxEnvasar.bind(this);
        this.successCantidadxEnvasar                    = this.successCantidadxEnvasar.bind(this);
        this.formato2                                   = this.formato2.bind(this);
        this.formato3                                   = this.formato3.bind(this);
        this.retornaDatosFicha                          = this.retornaDatosFicha.bind(this);
        this.retornaCantidadEnvasar                     = this.retornaCantidadEnvasar.bind(this);
        this.retornaKilosGalones                        = this.retornaKilosGalones.bind(this);
        this.verFormula                                 = this.verFormula.bind(this);
        this.successVerFormula                          = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula                      = Object.assign({}, this.gridOptions);

        this.successClose                               = this.successClose.bind(this);
    }

    initForm() {
        console.log("Iniciar Proceso @version: 1.01.0054 @author Cristian Ciro");
        this.getField('btnAgregarEnvase').setClick(this.modalEnvase);
        this.getField('btnGuardarEnvase').setClick(this.guardarEnvase);
        this.getField('btnCancelarEnvase').setClick(this.cancelarEnvase);        
        this.getField('btnIniciar').setClick(this.iniciarProceso);
        this.retornaDatosFicha();     
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_verformula_iniciar_proceso'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successVerFormula,
                error:this.error_,
                general: this.generalFormat,
                showMessage: false
            }
        );*/
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    retornaDatosFicha(){
        let datos = {
            datos: {
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*
        this.generalFormat.nombre_accion = 'produccion_fichas-iddatos'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:datos,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false

            });*/
    }
    retornaCantidadEnvasar(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'cantidadporenvasar', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successCantidadxEnvasar,
            error: this.error_,
            general: this.generalFormatPmv
        });

        //produccion_fichas-cantidadporenvasar
        /*this.generalFormat.nombre_accion = '6-Retorna_la_cantidad_por_envasar'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successCantidadxEnvasar,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false

            });*/
    }
    retornaKilosGalones(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'itemskilosgalones', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTotalkilos,
            error: this.error_,
            general: this.generalFormatPmv
        });

        // produccion_fichas_items-itemskilosgalones
        /*this.generalFormat.nombre_accion = '6-Traer_total_items_kilos_galones'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successTotalkilos,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false

            });*/
    }
    successDatosFicha(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('listaIniciar').setVisible(true);
            this.getField('listaIniciar').setItemsFichas(data.data);
            let datamodel = data.data;
            this.getField('puntos').setValue(datamodel[0].puntos);
            this.itemsFichas();
        }else{
            this.getField('listaIniciar').setVisible(false);
        }        
        this.retornaCantidadEnvasar();
        this.retornaKilosGalones();
    }

    itemsFichas(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successItemsFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '6-Retorna_los_items_de_la_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successItemsFichas,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false

            });*/
    }

    successItemsFichas(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0) {
            this.gridOptionsItemFichas['rowData'] = data.data;
            let configCellcol = new Map();
            configCellcol.set('cantidad_kilos',{cellRenderer:this.formato2, cellStyle: { textAlign: "right" },field: 'cantidad_kilos' });
            configCellcol.set('cantidad_galones',{cellRenderer:this.formato3, cellStyle: { textAlign: "right" },field: 'cantidad_galones' });
            this.getField('tablaIniciar').initData(this.gridOptionsItemFichas,configCellcol);
        }else{ 
          this.getField('tablaIniciar').toggle(false);
        }
        this.totalKilos();
        this.productosDelEnvasado();
    }

    formato2(props){
        let div = document.createElement('div');
        div.textContent = "".formatoPrecio(props.data.cantidad_kilos);
        if(props.data.etapa_id === 5){
            if(props.data.cantidad_galones > props.data.saldo_bodega_puntos){
                div.setAttribute('class','labelRed');
            }
        }else{
            if(props.data.cantidad_galones > props.data.saldo_bodega_materia_prima){
                div.setAttribute('class','labelRed');
            }
        }        
        return this.createElementJaivana(div);
    }
    formato3(props){
        let div = document.createElement('div');
        div.textContent = "".formatoPrecio(props.data.cantidad_galones);
        if(props.data.etapa_id === 5){
            if(props.data.cantidad_galones > props.data.saldo_bodega_puntos){
                div.setAttribute('class','labelRed');
            }
        }else{
            if(props.data.cantidad_galones > props.data.saldo_bodega_materia_prima){
                div.setAttribute('class','labelRed');
            }
        } 
        return this.createElementJaivana(div);
    }

    totalKilos(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'itemskilosgalones', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTotalkilos,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*let body = {
            value: this.props.data.id_ficha, 
        }
        this.generalFormat.nombre_accion = '6-Traer_total_items_kilos_galones'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successTotalkilos,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false

            });*/
    }
    successTotalkilos(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            let datamodel = data.data;
            this.getField('total_kilos').setValue(datamodel[0].total_kilos);
        }else{
            this.getField('total_kilos').setValue(0.0);
            this.alertGeneral.toggle(true,'Ficha Libre',"warning");
        }
    }

    modalEnvase(){
        this.getField('modalEnvase').handleClickOpen();
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('produccion_kit_id').setValue('');
        this.getField('codigo_producto').setValue('');
        this.getField('nombre_producto').setValue('');
        this.getField('factor').setValue('');
        this.getField('cantidad').setValue('');
        this.getField('kit').setValue('');
        this.getField('descripcion').setValue('');
        this.getField('articulo_id').setValue('');
        this.getField('es_envasado_id').setValue('');
    }

    guardarEnvase(){
        if(this.getField('cantidad').getValue() !== '' && this.getField('cantidad').getValue() !== ' '){
            this.getField('cantidad').setError(false,"");
            let datos = {
                datos: {
                    produccion_fichas_id:parseInt(this.props.data.id_ficha),
                    articulo_id:parseInt(this.getField('articulo_id').getValue()),
                    cantidad:this.getField('cantidad').getValue(),
                    produccion_kit_id:parseInt(this.getField('produccion_kit_id').getValue()),
                    actividad_id:this.props.data.actividad_id
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGuardarEnvase,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = "6-Crea_una_ficha_envasado"; 
            this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successGuardarEnvase,
                error:this.error_,
                general: this.generalFormat
            });*/
        }else{
            if(this.getField('cantidad').valid() && this.getField('cantidad').getValue() === '' ){
                this.getField('cantidad').setError(true,"Este campo es requerido");
            }
        }
    }
    successGuardarEnvase(response){
        if(response.estado_p === 200){
            this.getField('fieldAlert').toggle(true,"Ficha envasado creada exitosamente","success");
            this.getField('modalEnvase').handleClose();
            this.productosDelEnvasado();
        }else{
            this.getField('fieldAlert').toggle(true,"La ficha envasado no pudo ser creada","error");
        }
    }

    cancelarEnvase(){
        this.getField('modalEnvase').handleClose();
    }


    productosDelEnvasado(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            } 
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successProductosDelEnvasado,
            error: this.error_,
            general: this.generalFormatPmv
        });

        // produccion_fichas_envasado_inicial-fichaid prod-fichasenvasadoinicial
        /*
        this.generalFormat.nombre_accion = '6-Retorna_fichas_envasado_por_ficha_id'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successProductosDelEnvasado,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
    }
    successProductosDelEnvasado(data){
        console.log("Data = ",data);
        if (data.estado_p === 200){
            this.gridOptionsProductosEnvasado['rowData'] = data.data;
            //this.gridOptionsProductosEnvasado.paginationPageSize = 100;
            let configCellcol = new Map();
            configCellcol.set('accion', {cellRenderer:this.setChangeProductosEnvasado, field:'Acción'});
            this.getField('TbProductosDelEnvasado').initData(this.gridOptionsProductosEnvasado, configCellcol);
            this.cantidadxEnvasar();
        }else{ 
          this.getField('TbProductosDelEnvasado').toggle(false);
          this.getField('fieldAlert').toggle(true,"No hay envasado","error");
          this.cantidadxEnvasar();
        } 
    }

    cantidadxEnvasar(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'cantidadporenvasar', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successCantidadxEnvasar,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*let body = {
            value: this.props.data.id_ficha, 
        }
        this.generalFormat.nombre_accion = '6-Retorna_la_cantidad_por_envasar'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successCantidadxEnvasar,
                error:this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
    }
    successCantidadxEnvasar(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            let datamodel = data.data;
            this.getField('cantidad_a_producir').setValue(datamodel[0].cantidad_a_producir);
            this.getField('total_envasado').setValue(datamodel[0].total_envasado);
            this.getField('restante_envasar').setValue(datamodel[0].restante_envasar);
        }
    }

    setChangeProductosEnvasado(props){
        let button = document.createElement("input");
        button.onclick = () => this.setChangeProductosEnvasadoclick(props.data);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Eliminar");
        return this.createElementJaivana(button); 
    }
    setChangeProductosEnvasadoclick(data){
        let datos = {
            datos:{
                id: data.id,
                actividad_id:this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'eliminar', operacion_tipo: 'eliminar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'DELETE',
                body: datos,
                success: this.successProductosDelEnvasadoClick,
                error: this.error_,
                general: this.generalFormatPmv
            });
        /*this.generalFormat.nombre_accion = '6-Elimina_una_ficha_envasado'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'DELETE',
                body:body,
                success:this.successProductosDelEnvasadoClick,
                error:this.error_,
                general: this.generalFormat
            });*/
    }
    successProductosDelEnvasadoClick(response){
        if (response.estado_p === 200 ) {
            this.productosDelEnvasado();
        }
    }

   
    iniciarProceso(){
        this.getField('btnIniciar').setDisabled(true);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);

        let datos = {
            datos:{
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'trasladosaldo', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });

        // produccion_fichas-trasladosaldo
        /*this.generalFormat.nombre_accion = "6-Inicia_el_proceso"; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'POST',
            body:body,
            success:this.successCloseEstage,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    successClose(data){
        this.getField('btnIniciar').setDisabled(false);
        this.successCloseEstage(data);
    }

}
FormJaivana.addController("prod-iniciar",CustomIniciarProceso);
export default CustomIniciarProceso;